/*
  Customer reviews on the product page (sections/mm-pdp-reviews.liquid).
  Every review is already in the page; this only filters (all, with photos, a star level from the bars), sorts
  (newest, highest, lowest), shows them a page at a time ("Show more") and opens photos in a viewer.
  Without JavaScript every review is listed.
*/
(function () {
  document.querySelectorAll('[data-mm-reviews]').forEach(function (root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var list = root.querySelector('[data-mm-rv-list]');
    var items = Array.prototype.slice.call(list.children);
    var perPage = parseInt(root.dataset.page, 10) || 6;
    var controls = root.querySelector('[data-mm-rv-controls]');
    var sortSel = root.querySelector('[data-mm-rv-sort]');
    var more = root.querySelector('[data-mm-rv-more]');
    var empty = root.querySelector('[data-mm-rv-empty]');
    var live = root.querySelector('[data-mm-rv-live]');
    var chips = root.querySelectorAll('.mm-rv__chip');
    var filter = 'all';
    var shown = perPage;
    if (controls && items.length > 1) controls.hidden = false;

    function matches(li) {
      if (filter === 'all') return true;
      if (filter === 'photos') return Number(li.dataset.photos) > 0;
      return li.dataset.rating === filter;
    }
    function sortKey(li) {
      var mode = sortSel ? sortSel.value : 'new';
      var date = Number(li.dataset.date) || 0;
      var rating = Number(li.dataset.rating) || 0;
      if (mode === 'high') return [-rating, -date];
      if (mode === 'low') return [rating, -date];
      return [-date, 0];
    }
    function draw(announce) {
      var sorted = items.slice().sort(function (a, b) {
        var ka = sortKey(a), kb = sortKey(b);
        return ka[0] - kb[0] || ka[1] - kb[1];
      });
      sorted.forEach(function (li) { list.appendChild(li); });
      var visible = sorted.filter(matches);
      sorted.forEach(function (li) { li.hidden = true; });
      visible.slice(0, shown).forEach(function (li) { li.hidden = false; });
      if (more) more.hidden = visible.length <= shown;
      if (empty) empty.hidden = visible.length > 0;
      if (announce && live) live.textContent = visible.length + (visible.length === 1 ? ' review' : ' reviews');
    }
    function setFilter(value) {
      filter = value;
      shown = perPage;
      chips.forEach(function (c) {
        var on = c.dataset.filter === value;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      draw(true);
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (btn && !btn.disabled) {
        setFilter(btn.dataset.filter === filter && btn.classList.contains('mm-rv__bar-btn') ? 'all' : btn.dataset.filter);
        if (btn.classList.contains('mm-rv__bar-btn') && controls) controls.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });
    if (sortSel) sortSel.addEventListener('change', function () { shown = perPage; draw(true); });
    if (more) more.addEventListener('click', function () {
      var before = list.querySelectorAll('li:not([hidden])').length;
      shown += perPage;
      draw(false);
      var next = list.querySelectorAll('li:not([hidden])')[before];
      if (next) { next.tabIndex = -1; next.focus({ preventScroll: false }); }
    });
    draw(false);

    // Photo viewer
    var viewer = root.parentElement.querySelector('[data-mm-rv-viewer]');
    if (viewer && typeof viewer.showModal === 'function') {
      var img = viewer.querySelector('[data-mm-rv-img]');
      var cap = viewer.querySelector('[data-mm-rv-caption]');
      var opener = null;
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-photo]');
        if (!b) return;
        opener = b;
        img.src = b.dataset.photo;
        cap.textContent = b.dataset.caption || '';
        viewer.showModal();
      });
      viewer.querySelector('[data-mm-rv-close]').addEventListener('click', function () { viewer.close(); });
      viewer.addEventListener('click', function (e) { if (e.target === viewer) viewer.close(); });
      viewer.addEventListener('close', function () { img.removeAttribute('src'); if (opener) opener.focus(); });
    }
  });
})();
